module.exports = __webpack_public_path__ + "img/logo.79db19d4.png";